import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="341"
      height="310"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 341 310"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinejoin="round"
        transform="translate(-1358.5 -1018.5)"
      >
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M1450 1020l-4 2"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M1382 1039l-22 7v12l229 33 109-32v-14l-4-1"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1656 1058l-68 20v11"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1442 1058l126 19"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M1372 1061v84l202 39s4 .25 6-1 2-3 2-3l2-89"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1399 1088l152 21v41"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1551 1109l21-12"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1550 1152l18 22"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1384 1074l12 14v40l-14 12"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1396 1128l149 25"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M1371 1145s-3.98 1.88-6 4c-1.34 1.42-2 4-2 5 0 2.5 2 5 2 5l8 9v159"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1400 1317l-13-5-1-140 175 37"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1576 1211l-7-1"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1567 1212v41"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M1584 1199l1 48"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M1367 1152l211 40s3.25.75 6-1 5-6 5-6l83-23"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="3"
          d="M1690 1062l-2 137"
          opacity="1"
        ></path>
        <path
          strokeLinecap="butt"
          strokeWidth="2"
          d="M1464 1120.5c0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5 0 4.14-3.36 7.5-7.5 7.5-4.14 0-7.5-3.36-7.5-7.5z"
          opacity="1"
        ></path>
        <path
          strokeLinecap="round"
          strokeWidth="2"
          d="M1479 1119c-.05-.15 2.2-.05 2.44-.06 1.03-.06 2.9-.24 3.64.75 1.23 1.64.3 4.49-.27 6.29-1.86 5.84-7.81 4.02-10.81 2.02"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;